import React, { Component } from 'react'
import { Button, Popup, Icon } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import "../Toolbar.css";

class CategorySetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            setDisable: false
        }
    }

    createCategory = (e) => {

        dispatch.account.setAddCategoryModal(true);
    }

    deleteCategory = async (e) => {

        try {
            let categoryData = {};
            categoryData._id = this.props.selectedCategory._id;
            categoryData.prevName = this.props.selectedCategory.name;
            categoryData.categoryType = this.props.selectedCategory.baseCategory ? 'baseCategory' : this.props.selectedCategory.category ? 'category' : 'subCategory';
            categoryData.accountId = this.props.selectedAccount._id;
            if (categoryData.categoryType === 'subCategory') {
                categoryData.baseCategory = this.props.match.params.baseCategory;
                categoryData.category = this.props.match.params.category
            }
            if (categoryData.categoryType === 'category') {
                categoryData.category = this.props.match.params.category
            }
            await dispatch.account.checkCategoryAsync(categoryData);

            dispatch.account.setDeleteCategoryModal(true);
        } catch (error) {
            let message = <div className="confirmMessage">
                {error.message}
            </div>
            toastr.confirm(message, {
                onOk: () => { },
                disableCancel: true
            });
        }
    }
    exportCategories = async () => {
        let filename;
        let message;
        if (this.props.mainAreaContext === "knowledgeBank" || this.props.mainAreaContext === "baseCategory") {
            if(this.props.selectedOrganisation && this.props.selectedOrganisation.name){
                filename = this.props.selectedOrganisation.name;
            } else {
                filename = this.props.selectedAccount.name;
            }
            await dispatch.account.getCategoriesToExport('all');
            message = "Categories exported successfully"
        }
        else {
            filename = this.props.selectedCategory.name;
            await dispatch.account.getCategoriesToExport(this.props.selectedCategory._id);
            message = "Category expoted successfully"
        }

        var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.props.categoriesToExport));
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(dataStr);
        }
        else {
            //for firfox/chrome
            let link = document.createElement('a');
            link.href = dataStr;
            link.download = filename + '.kb';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            toastr.success(message)
        }
    }
    stopLoader = () => {
        this.setState({ processing: false });
        const { history } = this.props;
        if(this.props.selectedOrganisation && this.props.selectedOrganisation._id){
            history.push(`/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_wsSetting/categories`);
        } else {
            history.push(`/app/${this.props.selectedAccount._id}/settings/knowledgeBank`);
        }
    }
    fileUploaded = async (data) => {
        dispatch.app.setCollapsedResourcePaneIndexTemp(null);
        if (data.target.files[0].name.split('.').pop() === 'kb') {
            this.setState({ processing: true })
            var fileToLoad = data.target.files[0];
            var fileReader = new FileReader();

            fileReader.onload = async (fileLoadedEvent) => {
                if (fileLoadedEvent.target.result) {
                    await dispatch.account.importCategories({ data: fileLoadedEvent.target.result, accountId: this.props.selectedAccount._id, organisationId:this.props.selectedOrganisation.id });
                    this.stopLoader();
                } else {
                    toastr.error('Message', 'Invalid File.');
                    this.stopLoader();
                }
            };

            fileReader.readAsText(fileToLoad, "UTF-8");
            data.target.value = null;
        } else {
            toastr.error('Message', 'Invalid File.');
        }
    }

    render() {
        /**
         * User Access control 
         * Account user can not add or delete categories only owner can
         */

        let isDisabled = false;
        let userRoleInAccount = this.props.user && this.props.selectedAccount && this.props.user.accounts.filter((account, i) => { return account.id === this.props.selectedAccount._id })[0].role;
        if (userRoleInAccount === "user") {
            isDisabled = true;
        }
        
        let content
        if(this.props.mainAreaContext === "baseCategory") {
            content = "Create Knowledge Bank"
        }

        if(this.props.mainAreaContext === "category") {
            content = "Create Category"
        } 

        if(this.props.mainAreaContext === "subCategory") {
            content = "Create Sub Category"
        }

        return (
            <div className="toolBar header_buttons">
                {this.props.currentContext != 'acc-billing' ?
                    <Button.Group size='mini' >
                        {this.props.mainAreaContext === "knowledgeBank" || this.props.mainAreaContext === "category" || this.props.mainAreaContext === "baseCategory" || this.props.mainAreaContext === "subCategory" ?
                            <Popup className="popupStyled"
                                inverted
                                trigger={<span><Button
                                    disabled={(  this.props.baseModuleType === "Workspace" && !this.props.selectedOrganisation.fullControl)}
                                    icon='plus'
                                    className="clr-green"
                                    onClick={this.createCategory} />
                                </span>}
                                content={content} />
                            : ''}
                        {this.props.baseModuleType !== "Workspace" && this.props.selectedAccount && !this.props.selectedAccount.isPlatformAccount && (this.props.mainAreaContext === "knowledgeBank" || this.props.mainAreaContext === "baseCategory" || this.props.mainAreaContext === "category") ?
                            <Popup className="popupStyled"
                                inverted
                                trigger={<span><Button
                                    disabled={isDisabled}
                                    icon='cloud download'
                                    className="clr-green"
                                    onClick={this.exportCategories} />
                                </span>}
                                content='Export Category' />
                            : ''}
                        {this.props.baseModuleType !== "Workspace" && !isDisabled && this.props.selectedAccount && !this.props.selectedAccount.isPlatformAccount && (this.props.mainAreaContext === "baseCategory" || this.props.mainAreaContext === "knowledgeBank") && <Popup className="popupStyled z-index-999" inverted trigger={
                            <label className="exportIcon">
                                <Icon name='cloud upload' className={`f_16 ${this.props.activePageTab === 'createPlaybook' ? "clr-light-blue" : "clr-blue"}`} onMouseEnter={() => dispatch.app.setHelpContext("Import Categories")} style={{ verticalAlign: "top", margin: "-2px 0 0 0" }} />
                                <input type="file" name="file" id="file" className="inputfile" onChange={(e) => this.fileUploaded(e)} accept=".kb" />
                            </label>
                        }
                            content='Import Category'
                        />}
                        {this.props.baseModuleType === "Workspace" && this.props.selectedAccount && !this.props.selectedAccount.isPlatformAccount && (this.props.mainAreaContext === "knowledgeBank" || this.props.mainAreaContext === "baseCategory" || this.props.mainAreaContext === "category") ?
                            <Popup className="popupStyled"
                                inverted
                                trigger={<span><Button
                                    disabled={isDisabled}
                                    icon='cloud download'
                                    className="clr-green"
                                    onClick={this.exportCategories} />
                                </span>}
                                content='Export Category' />
                            : ''}
                        {this.props.baseModuleType === "Workspace" && !isDisabled && this.props.selectedAccount && !this.props.selectedAccount.isPlatformAccount && (this.props.mainAreaContext === "baseCategory" || this.props.mainAreaContext === "knowledgeBank") && <Popup className="popupStyled z-index-999" inverted trigger={
                            <label className="exportIcon">
                                <Icon name='cloud upload' className={`f_16 ${this.props.activePageTab === 'createPlaybook' ? "clr-light-blue" : "clr-blue"}`} onMouseEnter={() => dispatch.app.setHelpContext("Import Categories")} style={{ verticalAlign: "top", margin: "-2px 0 0 0" }} />
                                <input type="file" name="file" id="file" className="inputfile" onChange={(e) => this.fileUploaded(e)} accept=".kb" />
                            </label>
                        }
                            content='Import Category'
                        />}
                        {/* {this.props.baseModuleType === "Workspace" ?
                        <Popup className="popupStyled" inverted trigger={<span><Button
                            disabled={true}
                            icon='check circle'
                            className="clr-blue"
                        />
                        </span>}
                            content='Default' /> : null} */}

                    </Button.Group>
                    : ""}
            </div>
        )
    }
}
export default CategorySetting

